import axios from 'axios';

import history from './history';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 1200000, // 20 minutes
});

api.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (
      error.response.status === 401 &&
      error.response.data.error === 'Token invalid'
    ) {
      localStorage.removeItem('@Diretiva:token');
      localStorage.removeItem('@Diretiva:user');
      localStorage.removeItem('@Diretiva:company');
      localStorage.removeItem('@Diretiva:companyUser');
      localStorage.removeItem('@Diretiva:companyUsers');
      localStorage.removeItem('@Diretiva:apps');
      localStorage.removeItem('@Diretiva:companies');

      // Salvar a rota atual antes do redirecionamento
      const currentPath = window.location.pathname;
      const currentSearch = window.location.search;
      const fullPath = currentPath + currentSearch;

      // Só salvar se não for uma rota de login
      if (!currentPath.includes('signin') && !currentPath.includes('portal')) {
        localStorage.setItem('@Diretiva:redirectAfterLogin', fullPath);
      }

      // Verificar se está na tela mobile para manter na experiência mobile
      const isMobilePath =
        currentPath === '/mobile-signin' ||
        window.location.hostname === 'testes.cartefacile.com';

      if (isMobilePath) {
        history.push('/mobile-signin');
      } else {
        history.push('/signin');
      }
    }

    return Promise.reject(error);
  }
);

export default api;
